import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";

const validationSchema = yup.object().shape({
  sponsorId: yup.string().required("Your ID is required"),
  guestName: yup.string().required("Guest Name is required"),
  guestEmail: yup
    .string()
    .email("Invalid email format")
    .required("Guest Email is required"),
});

export default function DayLead() {
  const [searchParams] = useSearchParams();
  const sponsorId =  parseInt(searchParams.get("sponsorId")) || 111111;
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const formik = useFormik({
    initialValues: { sponsorId, guestName: "", guestEmail: "" },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      setErrorMessage("");
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URI}/api/Lead/AddNewLead`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              name: values.guestName,
              email: values.guestEmail,
              leadType: 0,
              sponsorId: parseInt(values.sponsorId),
            }),
          }
        );

        if (response.ok) {
          setSubmitted(true);
        } else {
          setErrorMessage("This email is already in the B3 U system");
        }
      } catch (error) {
        console.error("Error submitting lead", error);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    formik.setFieldValue("sponsorId", sponsorId);
  }, [sponsorId]);

  return (
    <div className="flex h-screen bg-gray-100">
      <div className="w-1/2 hidden lg:flex justify-center items-center bg-black">
        <img
          src="../../assets/images/subscription-image.png"
          alt="subscription"
        />
      </div>

      <div className="w-full lg:w-1/2 flex justify-center items-center">
        <div className="bg-white p-8 rounded-2xl shadow-xl w-[380px] border border-gray-300">
          {submitted ? (
            <div className="text-center">
              <h2 className="text-2xl roboto-bold text-[#00adef] mb-4">
                Success!
              </h2>
              <p className="text-gray-700">
                Your guest will be receiving an email to invite them for their 7
                Day Free Pass.
              </p>
              <p className="mt-4 text-gray-700">
                Be sure to follow up with them and invite them to explore B
                <span className="text-[#00adef]">3</span> U.
              </p>
              <p className="mt-4 text-gray-700">
                Encourage them to purchase their B
                <span className="text-[#00adef]">3</span> Bands and start their
                own BFR Journey.
              </p>
              <button
                className="w-fit p-3 mt-5 rounded-lg text-white roboto-medium text-lg bg-black hover:bg-gray-700 hover:shadow-lg transform"
                onClick={() => {
                  setSubmitted(false);
                  formik.resetForm();
                }}
              >
                Submit Another Guest
              </button>
            </div>
          ) : (
            <form onSubmit={formik.handleSubmit}>
              <h2 className="text-2xl roboto-bold text-gray-900 text-center mb-6">
                Share B<span className="text-[#00adef]">3</span> U with a friend
                or family member
              </h2>
              <h2 className="text-2xl roboto-bold text-[#00adef] text-center mb-6">
                7 Day Free Pass
              </h2>
              {errorMessage && (
                <p className="text-red-500 text-center mb-4">{errorMessage}</p>
              )}
              <div className="mb-5">
                <label className="block text-gray-800 mb-1">Your ID</label>
                <input
                  type="text"
                  name="sponsorId"
                  value={formik.values.sponsorId}
                  onChange={formik.handleChange}
                  disabled
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black "
                />
                {formik.errors.sponsorId && formik.touched.sponsorId && (
                  <p className="text-red-500 text-sm">
                    {formik.errors.sponsorId}
                  </p>
                )}
              </div>

              <div className="mb-5">
                <label className="block text-gray-800 mb-1">Guest Name</label>
                <input
                  type="text"
                  name="guestName"
                  value={formik.values.guestName}
                  onChange={formik.handleChange}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
                />
                {formik.errors.guestName && formik.touched.guestName && (
                  <p className="text-red-500 text-sm">
                    {formik.errors.guestName}
                  </p>
                )}
              </div>

              <div className="mb-5">
                <label className="block text-gray-800 mb-1">Guest Email</label>
                <input
                  type="email"
                  name="guestEmail"
                  value={formik.values.guestEmail}
                  onChange={formik.handleChange}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
                />
                {formik.errors.guestEmail && formik.touched.guestEmail && (
                  <p className="text-red-500 text-sm">
                    {formik.errors.guestEmail}
                  </p>
                )}
              </div>

              <button
                type="submit"
                className="w-full p-3 rounded-lg text-white roboto-medium text-lg bg-black hover:bg-gray-700 hover:shadow-lg transform"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
